import { Component, input, viewChild } from '@angular/core';
import { Notification, Button } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-documents-deleted-notification',
  imports: [Notification, NgIcon, Button, TranslocoPipe],
  templateUrl: './documents-deleted-notification.html',
})
export class DocumentsDeletedNotification {
  notification = viewChild(Notification);
  uuid = input.required<string>();
  duration = input.required<number>();

  selectedIds = input.required<string[]>();

  clickResetCallback = input.required<() => void>();

  protected onClickReset() {
    this.notification()?.dismiss();
    this.clickResetCallback()();
  }
}
